// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file devtool/emodel/v1/risk_calc_engine_service.proto (package devtool.emodel.v1, syntax proto3)
/* eslint-disable */

// A verbatim mirror of eModel's risk_calc_engine_service.proto (enechain/service-proto,
// services/emodel/emodel/v1), in a package this repository owns: eposition-app's
// protos do not import another service's protos, but the dev-tool RPCs carry
// eModel requests and responses as their own.
//
// Field numbers and types match emodel.v1 exactly. That is what lets
// devtoolemodel.Convert translate by re-encoding instead of copying field by
// field, so any change to eModel's messages has to be mirrored here by hand —
// TestMirrorMatchesEmodel fails if the two ever drift.

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../buf/validate/validate_pb";
import type { AccountIMResult, CalculationInput, FloatingIMByAccount, FloatingIMByIndex, FloatingIMPositionEntry, ICSTargetProduct, PSRDataSource, SpanV2SpreadCreditMethod } from "./im_model_pb";
import { file_devtool_emodel_v1_im_model } from "./im_model_pb";
import type { ExposureProfile, ValuationMode, XVAConfig, XVAMetrics } from "./market_model_pb";
import { file_devtool_emodel_v1_market_model } from "./market_model_pb";
import type { MTMIssue, MTMTickerGroupResult, TickerGroup } from "./mtm_model_pb";
import { file_devtool_emodel_v1_mtm_model } from "./mtm_model_pb";
import type { CalculatePFERequest, CalculatePFEResponse } from "./pfe_service_pb";
import { file_devtool_emodel_v1_pfe_service } from "./pfe_service_pb";
import type { CalculatePFEMatrices, DailyPowerCostEntry, DistributionMatrices, PFEDataPrepConfig, PortfolioAnalysisResult, RiskCalcAggregationConfig, RiskCalcMarketData, RiskCalcOutputConfig, RiskCalcPricingConfig, RiskCalcTradeData, SelectedDistributionMatrices, SIMResultAndDetail } from "./risk_calc_engine_model_pb";
import { file_devtool_emodel_v1_risk_calc_engine_model } from "./risk_calc_engine_model_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../../google/type/date_pb";
import { file_google_type_date } from "../../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file devtool/emodel/v1/risk_calc_engine_service.proto.
 */
export const file_devtool_emodel_v1_risk_calc_engine_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_devtool_emodel_v1_im_model, file_devtool_emodel_v1_market_model, file_devtool_emodel_v1_mtm_model, file_devtool_emodel_v1_pfe_service, file_devtool_emodel_v1_risk_calc_engine_model, file_google_protobuf_timestamp, file_google_type_date]);

/**
 * CalculateRiskリクエスト（Go RiskCalcEngineInput + CalculateByPortfolioInput 相当）
 *
 * @generated from message devtool.emodel.v1.CalculateRiskRequest
 */
export type CalculateRiskRequest = Message<"devtool.emodel.v1.CalculateRiskRequest"> & {
  /**
   * 基準日（計算の開始日）
   *
   * @generated from field: google.type.Date base_date = 1;
   */
  baseDate?: Date;

  /**
   * 日次マーケットデータ
   *
   * @generated from field: devtool.emodel.v1.RiskCalcMarketData market_data = 2;
   */
  marketData?: RiskCalcMarketData;

  /**
   * ポジションデータ
   *
   * @generated from field: devtool.emodel.v1.RiskCalcTradeData trade_data = 3;
   */
  tradeData?: RiskCalcTradeData;

  /**
   * プライシング設定
   *
   * @generated from field: devtool.emodel.v1.RiskCalcPricingConfig pricing_config = 4;
   */
  pricingConfig?: RiskCalcPricingConfig;

  /**
   * 集計設定
   *
   * @generated from field: devtool.emodel.v1.RiskCalcAggregationConfig aggregation_config = 5;
   */
  aggregationConfig?: RiskCalcAggregationConfig;

  /**
   * 出力設定
   *
   * @generated from field: devtool.emodel.v1.RiskCalcOutputConfig output_config = 6;
   */
  outputConfig?: RiskCalcOutputConfig;

  /**
   * トランザクションベースの入力モード（設定時はemodel内でpositions/power costs等を計算）
   *
   * @generated from field: optional devtool.emodel.v1.PFEDataPrepConfig raw_trade_data = 10;
   */
  rawTradeData?: PFEDataPrepConfig;

  /**
   * Valuation mode: LEGACY (default) or NPV_DRIVEN (ORE-style NPV cube approach)
   *
   * @generated from field: optional devtool.emodel.v1.ValuationMode valuation_mode = 11;
   */
  valuationMode?: ValuationMode;

  /**
   * XVA configuration (only used with NPV_DRIVEN mode)
   *
   * @generated from field: optional devtool.emodel.v1.XVAConfig xva_config = 12;
   */
  xvaConfig?: XVAConfig;
};

/**
 * Describes the message devtool.emodel.v1.CalculateRiskRequest.
 * Use `create(CalculateRiskRequestSchema)` to create a new message.
 */
export const CalculateRiskRequestSchema: GenMessage<CalculateRiskRequest> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 0);

/**
 * CalculateRiskレスポンス（Go RiskCalcEngineResponse + PortfolioPFESimResults 相当）
 *
 * @generated from message devtool.emodel.v1.CalculateRiskResponse
 */
export type CalculateRiskResponse = Message<"devtool.emodel.v1.CalculateRiskResponse"> & {
  /**
   * SIMResult配列（常に含まれる、sim_result_config指定時）
   *
   * @generated from field: repeated devtool.emodel.v1.SIMResultAndDetail sim_results = 1;
   */
  simResults: SIMResultAndDetail[];

  /**
   * CalculatePFEResult相当（detail_level >= FULL_MATRICES の場合）
   *
   * @generated from field: optional devtool.emodel.v1.CalculatePFEMatrices pfe_matrices = 2;
   */
  pfeMatrices?: CalculatePFEMatrices;

  /**
   * DistributionMatrix相当（detail_level >= FULL_MATRICES の場合）
   *
   * @generated from field: optional devtool.emodel.v1.DistributionMatrices distribution_matrices = 3;
   */
  distributionMatrices?: DistributionMatrices;

  /**
   * SelectedPnlDistributionMatrix相当（detail_level >= DETAILED の場合）
   *
   * @generated from field: optional devtool.emodel.v1.SelectedDistributionMatrices selected_distribution_matrices = 4;
   */
  selectedDistributionMatrices?: SelectedDistributionMatrices;

  /**
   * リクエストID（トレース用）
   *
   * @generated from field: string request_id = 5;
   */
  requestId: string;

  /**
   * 計算時間（ミリ秒）
   *
   * @generated from field: int32 runtime_ms = 6;
   */
  runtimeMs: number;

  /**
   * 実際に使用された評価日数
   *
   * @generated from field: int32 evaluation_days = 7;
   */
  evaluationDays: number;

  /**
   * 実際に使用された評価データ数
   *
   * @generated from field: int32 evaluation_data_count = 8;
   */
  evaluationDataCount: number;

  /**
   * Floating現在MTM合計
   *
   * @generated from field: double floating_current_mtm = 10;
   */
  floatingCurrentMtm: number;

  /**
   * Floating現在MTM配列（ポジション毎）
   *
   * @generated from field: repeated double floating_current_mtm_by_position = 11;
   */
  floatingCurrentMtmByPosition: number[];

  /**
   * Exposure profile (EPE/ENE/PFE curves)
   *
   * @generated from field: optional devtool.emodel.v1.ExposureProfile exposure_profile = 20;
   */
  exposureProfile?: ExposureProfile;

  /**
   * XVA metrics (CVA/DVA/FVA)
   *
   * @generated from field: optional devtool.emodel.v1.XVAMetrics xva_metrics = 21;
   */
  xvaMetrics?: XVAMetrics;
};

/**
 * Describes the message devtool.emodel.v1.CalculateRiskResponse.
 * Use `create(CalculateRiskResponseSchema)` to create a new message.
 */
export const CalculateRiskResponseSchema: GenMessage<CalculateRiskResponse> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 1);

/**
 * PortfolioAnalysisResult生成リクエスト
 *
 * @generated from message devtool.emodel.v1.GetPortfolioAnalysisResultsRequest
 */
export type GetPortfolioAnalysisResultsRequest = Message<"devtool.emodel.v1.GetPortfolioAnalysisResultsRequest"> & {
  /**
   * SIMResult配列（CalculateRiskの出力から）
   *
   * @generated from field: repeated devtool.emodel.v1.SIMResultAndDetail sim_results = 1;
   */
  simResults: SIMResultAndDetail[];

  /**
   * ケースID
   *
   * @generated from field: string case_id = 2;
   */
  caseId: string;

  /**
   * 組織ID配列
   *
   * @generated from field: repeated string organization_ids = 3;
   */
  organizationIds: string[];

  /**
   * 組織名配列
   *
   * @generated from field: repeated string organization_names = 4;
   */
  organizationNames: string[];

  /**
   * 変動電力コスト（日次）
   *
   * @generated from field: repeated devtool.emodel.v1.DailyPowerCostEntry unfixed_power_costs = 5;
   */
  unfixedPowerCosts: DailyPowerCostEntry[];
};

/**
 * Describes the message devtool.emodel.v1.GetPortfolioAnalysisResultsRequest.
 * Use `create(GetPortfolioAnalysisResultsRequestSchema)` to create a new message.
 */
export const GetPortfolioAnalysisResultsRequestSchema: GenMessage<GetPortfolioAnalysisResultsRequest> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 2);

/**
 * PortfolioAnalysisResult生成レスポンス
 *
 * @generated from message devtool.emodel.v1.GetPortfolioAnalysisResultsResponse
 */
export type GetPortfolioAnalysisResultsResponse = Message<"devtool.emodel.v1.GetPortfolioAnalysisResultsResponse"> & {
  /**
   * 分析結果配列
   *
   * @generated from field: repeated devtool.emodel.v1.PortfolioAnalysisResult results = 1;
   */
  results: PortfolioAnalysisResult[];

  /**
   * リクエストID
   *
   * @generated from field: string request_id = 2;
   */
  requestId: string;

  /**
   * 計算時間（ミリ秒）
   *
   * @generated from field: int32 runtime_ms = 3;
   */
  runtimeMs: number;
};

/**
 * Describes the message devtool.emodel.v1.GetPortfolioAnalysisResultsResponse.
 * Use `create(GetPortfolioAnalysisResultsResponseSchema)` to create a new message.
 */
export const GetPortfolioAnalysisResultsResponseSchema: GenMessage<GetPortfolioAnalysisResultsResponse> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 3);

/**
 * Floating IM計算リクエスト（ヒストリカルシミュレーション方式）
 *
 * @generated from message devtool.emodel.v1.CalculateFloatingIMRequest
 */
export type CalculateFloatingIMRequest = Message<"devtool.emodel.v1.CalculateFloatingIMRequest"> & {
  /**
   * 基準日
   *
   * @generated from field: google.type.Date base_date = 1;
   */
  baseDate?: Date;

  /**
   * ポジション一覧
   *
   * @generated from field: repeated devtool.emodel.v1.FloatingIMPositionEntry positions = 2;
   */
  positions: FloatingIMPositionEntry[];

  /**
   * 観測期間（日数）。0以下の場合は利用可能な全データを使用
   *
   * @generated from field: int32 observation_period = 3;
   */
  observationPeriod: number;

  /**
   * 信頼水準（basis points単位。例: 9750 = 97.5%）。0の場合はデフォルト9750
   *
   * @generated from field: int32 confidence_level_bps = 4;
   */
  confidenceLevelBps: number;

  /**
   * 調整係数。0の場合はデフォルト1.0
   *
   * @generated from field: double adjustment_factor = 5;
   */
  adjustmentFactor: number;
};

/**
 * Describes the message devtool.emodel.v1.CalculateFloatingIMRequest.
 * Use `create(CalculateFloatingIMRequestSchema)` to create a new message.
 */
export const CalculateFloatingIMRequestSchema: GenMessage<CalculateFloatingIMRequest> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 4);

/**
 * Floating IM計算レスポンス
 *
 * @generated from message devtool.emodel.v1.CalculateFloatingIMResponse
 */
export type CalculateFloatingIMResponse = Message<"devtool.emodel.v1.CalculateFloatingIMResponse"> & {
  /**
   * 合計Floating IM
   *
   * @generated from field: double total_floating_im = 1;
   */
  totalFloatingIm: number;

  /**
   * インデックス別IM
   *
   * @generated from field: repeated devtool.emodel.v1.FloatingIMByIndex im_by_index = 2;
   */
  imByIndex: FloatingIMByIndex[];

  /**
   * 口座別IM
   *
   * @generated from field: repeated devtool.emodel.v1.FloatingIMByAccount im_by_account = 3;
   */
  imByAccount: FloatingIMByAccount[];

  /**
   * 使用されたパーセンタイル（basis points単位。例: 9750 = 97.5%）
   *
   * @generated from field: int32 used_percentile_bps = 4;
   */
  usedPercentileBps: number;

  /**
   * 使用された観測期間
   *
   * @generated from field: int32 used_observation_period = 5;
   */
  usedObservationPeriod: number;

  /**
   * 使用された調整係数
   *
   * @generated from field: double used_adjustment_factor = 6;
   */
  usedAdjustmentFactor: number;

  /**
   * リクエストID
   *
   * @generated from field: string request_id = 7;
   */
  requestId: string;

  /**
   * 計算時間（ミリ秒）
   *
   * @generated from field: int32 runtime_ms = 8;
   */
  runtimeMs: number;
};

/**
 * Describes the message devtool.emodel.v1.CalculateFloatingIMResponse.
 * Use `create(CalculateFloatingIMResponseSchema)` to create a new message.
 */
export const CalculateFloatingIMResponseSchema: GenMessage<CalculateFloatingIMResponse> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 5);

/**
 * 統合 IM 計算リクエスト
 *
 * @generated from message devtool.emodel.v1.CalculateCombinedIMRequest
 */
export type CalculateCombinedIMRequest = Message<"devtool.emodel.v1.CalculateCombinedIMRequest"> & {
  /**
   * 基準日
   *
   * @generated from field: google.type.Date base_date = 1;
   */
  baseDate?: Date;

  /**
   * ポジション一覧（Floating IM と電力 IM の両方に使用）
   *
   * @generated from field: repeated devtool.emodel.v1.FloatingIMPositionEntry positions = 2;
   */
  positions: FloatingIMPositionEntry[];

  /**
   * Floating IM パラメータ: 観測期間（日数）。0以下の場合は利用可能な全データを使用
   *
   * @generated from field: int32 observation_period = 3;
   */
  observationPeriod: number;

  /**
   * Floating IM パラメータ: 信頼水準（basis points単位）。0の場合はデフォルト9750
   *
   * @generated from field: int32 confidence_level_bps = 4;
   */
  confidenceLevelBps: number;

  /**
   * Floating IM パラメータ: 調整係数。0の場合はデフォルト1.0
   *
   * @generated from field: double adjustment_factor = 5;
   */
  adjustmentFactor: number;

  /**
   * 電力 IM パラメータ: PSRデータソース
   *
   * @generated from field: devtool.emodel.v1.PSRDataSource psr_data_source = 6;
   */
  psrDataSource: PSRDataSource;

  /**
   * 電力 IM パラメータ: ICSルックバック日数
   *
   * @generated from field: optional int32 ics_lookback_days = 7;
   */
  icsLookbackDays?: number;

  /**
   * PSRデータ参照日。未指定の場合は base_date をデフォルトとする
   *
   * @generated from field: optional google.type.Date data_reference_date = 8;
   */
  dataReferenceDate?: Date;

  /**
   * ICSターゲットプロダクト。指定された area + hour_type ペアのみICSクレジットを適用。空の場合は全ICS有効（後方互換）
   *
   * @generated from field: repeated devtool.emodel.v1.ICSTargetProduct ics_target_products = 10;
   */
  icsTargetProducts: ICSTargetProduct[];

  /**
   * true の場合、SPAN V2 が実際に使った PSR / Spread / Position の入力スナップショットを
   * レスポンスに同梱する。Power IM (SPAN V2) パスでのみ有効。
   *
   * @generated from field: optional bool with_calculation_input = 11;
   */
  withCalculationInput?: boolean;

  /**
   * SPAN V2 のスプレッドクレジットの方式。未指定の場合は
   * SPAN_V2_SPREAD_CREDIT_METHOD_ABSOLUTE_QUANTITY（v1.0）で計算する。
   * 実際に使った方式は SPANV2Result.spread_credit_method に返る。
   *
   * @generated from field: devtool.emodel.v1.SpanV2SpreadCreditMethod span_v2_spread_credit_method = 12;
   */
  spanV2SpreadCreditMethod: SpanV2SpreadCreditMethod;
};

/**
 * Describes the message devtool.emodel.v1.CalculateCombinedIMRequest.
 * Use `create(CalculateCombinedIMRequestSchema)` to create a new message.
 */
export const CalculateCombinedIMRequestSchema: GenMessage<CalculateCombinedIMRequest> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 6);

/**
 * 統合 IM 計算レスポンス
 *
 * @generated from message devtool.emodel.v1.CalculateCombinedIMResponse
 */
export type CalculateCombinedIMResponse = Message<"devtool.emodel.v1.CalculateCombinedIMResponse"> & {
  /**
   * リクエストID
   *
   * @generated from field: string request_id = 4;
   */
  requestId: string;

  /**
   * 計算時間（ミリ秒）
   *
   * @generated from field: int32 runtime_ms = 5;
   */
  runtimeMs: number;

  /**
   * アカウント別 IM 結果
   *
   * @generated from field: repeated devtool.emodel.v1.AccountIMResult results = 6;
   */
  results: AccountIMResult[];

  /**
   * 計算基準日（リクエストの base_date）
   *
   * @generated from field: google.type.Date calculation_date = 7;
   */
  calculationDate?: Date;

  /**
   * PSRデータ参照日（実際に使用された日付）
   *
   * @generated from field: google.type.Date data_reference_date = 8;
   */
  dataReferenceDate?: Date;

  /**
   * SPAN V2 が実際に使った PSR / Spread / Position の入力スナップショット。
   * リクエストで with_calculation_input=true のときのみセットされる。
   *
   * @generated from field: optional devtool.emodel.v1.CalculationInput calculation_input = 9;
   */
  calculationInput?: CalculationInput;
};

/**
 * Describes the message devtool.emodel.v1.CalculateCombinedIMResponse.
 * Use `create(CalculateCombinedIMResponseSchema)` to create a new message.
 */
export const CalculateCombinedIMResponseSchema: GenMessage<CalculateCombinedIMResponse> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 7);

/**
 * @generated from message devtool.emodel.v1.UnifiedAnalysisIssue
 */
export type UnifiedAnalysisIssue = Message<"devtool.emodel.v1.UnifiedAnalysisIssue"> & {
  /**
   * @generated from field: devtool.emodel.v1.UnifiedAnalysisComponent component = 1;
   */
  component: UnifiedAnalysisComponent;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message devtool.emodel.v1.UnifiedAnalysisIssue.
 * Use `create(UnifiedAnalysisIssueSchema)` to create a new message.
 */
export const UnifiedAnalysisIssueSchema: GenMessage<UnifiedAnalysisIssue> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 8);

/**
 * @generated from message devtool.emodel.v1.RunUnifiedAnalysisRequest
 */
export type RunUnifiedAnalysisRequest = Message<"devtool.emodel.v1.RunUnifiedAnalysisRequest"> & {
  /**
   * @generated from field: optional devtool.emodel.v1.CalculateRiskRequest risk_request = 1;
   */
  riskRequest?: CalculateRiskRequest;

  /**
   * @generated from field: optional devtool.emodel.v1.CalculatePFERequest quick_pfe_request = 3;
   */
  quickPfeRequest?: CalculatePFERequest;

  /**
   * @generated from field: optional devtool.emodel.v1.CalculateCombinedIMRequest combined_im_request = 4;
   */
  combinedImRequest?: CalculateCombinedIMRequest;
};

/**
 * Describes the message devtool.emodel.v1.RunUnifiedAnalysisRequest.
 * Use `create(RunUnifiedAnalysisRequestSchema)` to create a new message.
 */
export const RunUnifiedAnalysisRequestSchema: GenMessage<RunUnifiedAnalysisRequest> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 9);

/**
 * @generated from message devtool.emodel.v1.RunUnifiedAnalysisResponse
 */
export type RunUnifiedAnalysisResponse = Message<"devtool.emodel.v1.RunUnifiedAnalysisResponse"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: int32 runtime_ms = 2;
   */
  runtimeMs: number;

  /**
   * @generated from field: optional devtool.emodel.v1.CalculateRiskResponse risk_response = 3;
   */
  riskResponse?: CalculateRiskResponse;

  /**
   * @generated from field: optional devtool.emodel.v1.CalculatePFEResponse quick_pfe_response = 5;
   */
  quickPfeResponse?: CalculatePFEResponse;

  /**
   * @generated from field: optional devtool.emodel.v1.CalculateCombinedIMResponse combined_im_response = 6;
   */
  combinedImResponse?: CalculateCombinedIMResponse;

  /**
   * @generated from field: repeated devtool.emodel.v1.UnifiedAnalysisIssue issues = 7;
   */
  issues: UnifiedAnalysisIssue[];

  /**
   * @generated from field: int32 requested_components = 8;
   */
  requestedComponents: number;

  /**
   * @generated from field: int32 successful_components = 9;
   */
  successfulComponents: number;
};

/**
 * Describes the message devtool.emodel.v1.RunUnifiedAnalysisResponse.
 * Use `create(RunUnifiedAnalysisResponseSchema)` to create a new message.
 */
export const RunUnifiedAnalysisResponseSchema: GenMessage<RunUnifiedAnalysisResponse> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 10);

/**
 * CalculateMTMリクエスト
 *
 * @generated from message devtool.emodel.v1.CalculateMTMRequest
 */
export type CalculateMTMRequest = Message<"devtool.emodel.v1.CalculateMTMRequest"> & {
  /**
   * 基準日（カーブ選択に使用）
   *
   * @generated from field: google.type.Date reference_date = 1;
   */
  referenceDate?: Date;

  /**
   * tickerごとにグルーピングされたポジション + 確定済み市場価格
   *
   * @generated from field: repeated devtool.emodel.v1.TickerGroup ticker_groups = 2;
   */
  tickerGroups: TickerGroup[];
};

/**
 * Describes the message devtool.emodel.v1.CalculateMTMRequest.
 * Use `create(CalculateMTMRequestSchema)` to create a new message.
 */
export const CalculateMTMRequestSchema: GenMessage<CalculateMTMRequest> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 11);

/**
 * CalculateMTMレスポンス
 *
 * @generated from message devtool.emodel.v1.CalculateMTMResponse
 */
export type CalculateMTMResponse = Message<"devtool.emodel.v1.CalculateMTMResponse"> & {
  /**
   * @generated from field: repeated devtool.emodel.v1.MTMTickerGroupResult ticker_group_results = 1;
   */
  tickerGroupResults: MTMTickerGroupResult[];

  /**
   * @generated from field: int32 runtime_ms = 2;
   */
  runtimeMs: number;

  /**
   * @generated from field: repeated devtool.emodel.v1.MTMIssue issues = 3;
   */
  issues: MTMIssue[];
};

/**
 * Describes the message devtool.emodel.v1.CalculateMTMResponse.
 * Use `create(CalculateMTMResponseSchema)` to create a new message.
 */
export const CalculateMTMResponseSchema: GenMessage<CalculateMTMResponse> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 12);

/**
 * @generated from message devtool.emodel.v1.QueryPriceTimeSeriesRequest
 */
export type QueryPriceTimeSeriesRequest = Message<"devtool.emodel.v1.QueryPriceTimeSeriesRequest"> & {
  /**
   * シンボル（e.g. "TOKYO_BASE"）
   *
   * @generated from field: string symbol = 1;
   */
  symbol: string;

  /**
   * 限月（e.g. 2026-04-01）
   *
   * @generated from field: google.type.Date contract_month = 2;
   */
  contractMonth?: Date;
};

/**
 * Describes the message devtool.emodel.v1.QueryPriceTimeSeriesRequest.
 * Use `create(QueryPriceTimeSeriesRequestSchema)` to create a new message.
 */
export const QueryPriceTimeSeriesRequestSchema: GenMessage<QueryPriceTimeSeriesRequest> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 13);

/**
 * @generated from message devtool.emodel.v1.QueryPriceTimeSeriesResponse
 */
export type QueryPriceTimeSeriesResponse = Message<"devtool.emodel.v1.QueryPriceTimeSeriesResponse"> & {
  /**
   * 時系列データ
   *
   * @generated from field: repeated devtool.emodel.v1.PriceTimeSeriesPoint points = 1;
   */
  points: PriceTimeSeriesPoint[];

  /**
   * シンボル
   *
   * @generated from field: string symbol = 2;
   */
  symbol: string;

  /**
   * 限月
   *
   * @generated from field: google.type.Date contract_month = 3;
   */
  contractMonth?: Date;
};

/**
 * Describes the message devtool.emodel.v1.QueryPriceTimeSeriesResponse.
 * Use `create(QueryPriceTimeSeriesResponseSchema)` to create a new message.
 */
export const QueryPriceTimeSeriesResponseSchema: GenMessage<QueryPriceTimeSeriesResponse> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 14);

/**
 * PriceTimeSeriesPoint: 1日分の価格ポイント
 *
 * @generated from message devtool.emodel.v1.PriceTimeSeriesPoint
 */
export type PriceTimeSeriesPoint = Message<"devtool.emodel.v1.PriceTimeSeriesPoint"> & {
  /**
   * 基準日
   *
   * @generated from field: google.type.Date date = 1;
   */
  date?: Date;

  /**
   * Forward価格
   *
   * @generated from field: double price = 2;
   */
  price: number;
};

/**
 * Describes the message devtool.emodel.v1.PriceTimeSeriesPoint.
 * Use `create(PriceTimeSeriesPointSchema)` to create a new message.
 */
export const PriceTimeSeriesPointSchema: GenMessage<PriceTimeSeriesPoint> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 15);

/**
 * UpsertForwardCurveリクエスト
 *
 * @generated from message devtool.emodel.v1.UpsertForwardCurveRequest
 */
export type UpsertForwardCurveRequest = Message<"devtool.emodel.v1.UpsertForwardCurveRequest"> & {
  /**
   * カーブ識別子（GCS パスと forward_curve_metadata.ticker のキー。
   * 例: "ENECHAIN_TOKYO_BASE_MONTH"）。opaque な文字列で、命名は呼び出し側の責務
   *
   * @generated from field: string ticker = 1;
   */
  ticker: string;

  /**
   * スナップショット日（カーブの基準日）
   *
   * @generated from field: google.type.Date available_date = 2;
   */
  availableDate?: Date;

  /**
   * カーブデータ点。CSV にはリクエスト順のまま書かれる
   *
   * @generated from field: repeated devtool.emodel.v1.ForwardCurvePoint points = 3;
   */
  points: ForwardCurvePoint[];

  /**
   * 任意メモ。呼び出し元サービス名などの provenance を残す
   *
   * @generated from field: string memo = 4;
   */
  memo: string;

  /**
   * 各点が表す期間（tenor）。点の日付はその期間の開始日でなければならない。必須（未指定は InvalidArgument）。
   * MTM（CalculateMTM / CalculatePowerMTM）は記録された tenor で価格を引く
   *
   * @generated from field: devtool.emodel.v1.ForwardCurveTenor tenor = 5;
   */
  tenor: ForwardCurveTenor;
};

/**
 * Describes the message devtool.emodel.v1.UpsertForwardCurveRequest.
 * Use `create(UpsertForwardCurveRequestSchema)` to create a new message.
 */
export const UpsertForwardCurveRequestSchema: GenMessage<UpsertForwardCurveRequest> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 16);

/**
 * ForwardCurvePoint: 1点分の (日付, 価格)
 *
 * @generated from message devtool.emodel.v1.ForwardCurvePoint
 */
export type ForwardCurvePoint = Message<"devtool.emodel.v1.ForwardCurvePoint"> & {
  /**
   * 日付（通常は限月の月初）
   *
   * @generated from field: google.type.Date date = 1;
   */
  date?: Date;

  /**
   * 価格
   *
   * @generated from field: double price = 2;
   */
  price: number;
};

/**
 * Describes the message devtool.emodel.v1.ForwardCurvePoint.
 * Use `create(ForwardCurvePointSchema)` to create a new message.
 */
export const ForwardCurvePointSchema: GenMessage<ForwardCurvePoint> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 17);

/**
 * UpsertForwardCurveレスポンス
 *
 * @generated from message devtool.emodel.v1.UpsertForwardCurveResponse
 */
export type UpsertForwardCurveResponse = Message<"devtool.emodel.v1.UpsertForwardCurveResponse"> & {
  /**
   * metadata に記録した contract month 範囲（points の日付の min/max）
   *
   * @generated from field: google.type.Date contract_month_from = 1;
   */
  contractMonthFrom?: Date;

  /**
   * @generated from field: google.type.Date contract_month_to = 2;
   */
  contractMonthTo?: Date;

  /**
   * 書き込んだデータ点数
   *
   * @generated from field: int32 point_count = 3;
   */
  pointCount: number;
};

/**
 * Describes the message devtool.emodel.v1.UpsertForwardCurveResponse.
 * Use `create(UpsertForwardCurveResponseSchema)` to create a new message.
 */
export const UpsertForwardCurveResponseSchema: GenMessage<UpsertForwardCurveResponse> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 18);

/**
 * GetForwardCurvesリクエスト
 *
 * @generated from message devtool.emodel.v1.GetForwardCurvesRequest
 */
export type GetForwardCurvesRequest = Message<"devtool.emodel.v1.GetForwardCurvesRequest"> & {
  /**
   * 基準日。ticker ごとに、この日以前で最新のスナップショットを返す
   *
   * @generated from field: google.type.Date reference_date = 1;
   */
  referenceDate?: Date;

  /**
   * カーブ識別子（forward_curve_metadata.ticker。例: "ENECHAIN_TOKYO_BASE_MONTH"、floating の指標の ticker）
   *
   * @generated from field: repeated string tickers = 2;
   */
  tickers: string[];
};

/**
 * Describes the message devtool.emodel.v1.GetForwardCurvesRequest.
 * Use `create(GetForwardCurvesRequestSchema)` to create a new message.
 */
export const GetForwardCurvesRequestSchema: GenMessage<GetForwardCurvesRequest> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 19);

/**
 * GetForwardCurvesレスポンス
 *
 * @generated from message devtool.emodel.v1.GetForwardCurvesResponse
 */
export type GetForwardCurvesResponse = Message<"devtool.emodel.v1.GetForwardCurvesResponse"> & {
  /**
   * ticker ごとのカーブ（リクエストの tickers の順に、ticker ごとにちょうど1つ。基準日以前にスナップショットが無い ticker は、
   * available_date を未設定・points を空にして返す）
   *
   * @generated from field: repeated devtool.emodel.v1.ForwardCurve curves = 1;
   */
  curves: ForwardCurve[];
};

/**
 * Describes the message devtool.emodel.v1.GetForwardCurvesResponse.
 * Use `create(GetForwardCurvesResponseSchema)` to create a new message.
 */
export const GetForwardCurvesResponseSchema: GenMessage<GetForwardCurvesResponse> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 20);

/**
 * ForwardCurve: 1 ticker の forward curve のスナップショット
 *
 * @generated from message devtool.emodel.v1.ForwardCurve
 */
export type ForwardCurve = Message<"devtool.emodel.v1.ForwardCurve"> & {
  /**
   * カーブ識別子
   *
   * @generated from field: string ticker = 1;
   */
  ticker: string;

  /**
   * スナップショット日（基準日以前にスナップショットが無ければ未設定）
   *
   * @generated from field: google.type.Date available_date = 2;
   */
  availableDate?: Date;

  /**
   * メタデータの限月の範囲（スナップショットのデータ点の日付の最小・最大。スナップショットが無い、または範囲が記録されていない
   * 古いスナップショットなら未設定）
   *
   * @generated from field: google.type.Date contract_month_from = 3;
   */
  contractMonthFrom?: Date;

  /**
   * @generated from field: google.type.Date contract_month_to = 4;
   */
  contractMonthTo?: Date;

  /**
   * カーブデータ点。点の日付と価格はスナップショットに保存されたまま（月初に寄せたりしない）で、並びは日付の昇順に並べ替える
   * （UpsertForwardCurve は点を依頼の順のまま保存するので、保存された順とは限らない）。同じ日付の点は保存された順
   *
   * @generated from field: repeated devtool.emodel.v1.ForwardCurvePoint points = 5;
   */
  points: ForwardCurvePoint[];

  /**
   * スナップショットの各点が表す期間（tenor）。点の日付はその期間の開始日。
   * すべてのスナップショットに記録されている
   *
   * @generated from field: devtool.emodel.v1.ForwardCurveTenor tenor = 6;
   */
  tenor: ForwardCurveTenor;
};

/**
 * Describes the message devtool.emodel.v1.ForwardCurve.
 * Use `create(ForwardCurveSchema)` to create a new message.
 */
export const ForwardCurveSchema: GenMessage<ForwardCurve> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 21);

/**
 * RegisterFloatingIndexリクエスト
 *
 * @generated from message devtool.emodel.v1.RegisterFloatingIndexRequest
 */
export type RegisterFloatingIndexRequest = Message<"devtool.emodel.v1.RegisterFloatingIndexRequest"> & {
  /**
   * 変動指標の ID（UUID）。呼び出し側が採番し、やり直しでも同じ値を送る。ePosition の約定が参照する変動指標の ID と同じ値にする
   *
   * @generated from field: string floating_index_id = 1;
   */
  floatingIndexId: string;

  /**
   * コード（例: "JERAGM_Wholesale_TBL_JKM_FY26"）。eModel の中で一意で、forward curve の ticker になる
   *
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * 名前
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * 式ツリー。部品の並びと定数の書き方は、そのまま保存して返す
   *
   * @generated from field: devtool.emodel.v1.FloatingIndexExpression expression = 4;
   */
  expression?: FloatingIndexExpression;

  /**
   * 登録者（登録の操作をした人の識別子）
   *
   * @generated from field: string registered_by = 5;
   */
  registeredBy: string;

  /**
   * forward の出どころ。無ければ forward curve を書き出さない定義になる。
   * forward_source と historical_source はどちらか片方は無くてよいが、両方無い依頼は eModel が断る
   *
   * @generated from field: devtool.emodel.v1.FloatingIndexForwardSource forward_source = 6;
   */
  forwardSource?: FloatingIndexForwardSource;

  /**
   * historical の出どころ（作り方を含む）。無ければ historical のシナリオを書き出さない定義になる。
   * forward_source と historical_source はどちらか片方は無くてよいが、両方無い依頼は eModel が断る
   *
   * @generated from field: devtool.emodel.v1.FloatingIndexHistoricalSource historical_source = 7;
   */
  historicalSource?: FloatingIndexHistoricalSource;
};

/**
 * Describes the message devtool.emodel.v1.RegisterFloatingIndexRequest.
 * Use `create(RegisterFloatingIndexRequestSchema)` to create a new message.
 */
export const RegisterFloatingIndexRequestSchema: GenMessage<RegisterFloatingIndexRequest> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 22);

/**
 * RegisterFloatingIndexレスポンス
 *
 * @generated from message devtool.emodel.v1.RegisterFloatingIndexResponse
 */
export type RegisterFloatingIndexResponse = Message<"devtool.emodel.v1.RegisterFloatingIndexResponse"> & {
  /**
   * 登録された定義。同じ ID・同じ内容で既に登録済みだった場合は、その登録済みの定義（登録者・登録日時は最初の登録のもの）
   *
   * @generated from field: devtool.emodel.v1.FloatingIndexDefinition floating_index = 1;
   */
  floatingIndex?: FloatingIndexDefinition;
};

/**
 * Describes the message devtool.emodel.v1.RegisterFloatingIndexResponse.
 * Use `create(RegisterFloatingIndexResponseSchema)` to create a new message.
 */
export const RegisterFloatingIndexResponseSchema: GenMessage<RegisterFloatingIndexResponse> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 23);

/**
 * ListFloatingIndexesリクエスト
 *
 * @generated from message devtool.emodel.v1.ListFloatingIndexesRequest
 */
export type ListFloatingIndexesRequest = Message<"devtool.emodel.v1.ListFloatingIndexesRequest"> & {
};

/**
 * Describes the message devtool.emodel.v1.ListFloatingIndexesRequest.
 * Use `create(ListFloatingIndexesRequestSchema)` to create a new message.
 */
export const ListFloatingIndexesRequestSchema: GenMessage<ListFloatingIndexesRequest> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 24);

/**
 * ListFloatingIndexesレスポンス
 *
 * @generated from message devtool.emodel.v1.ListFloatingIndexesResponse
 */
export type ListFloatingIndexesResponse = Message<"devtool.emodel.v1.ListFloatingIndexesResponse"> & {
  /**
   * 登録された変動指標の定義（全件）
   *
   * @generated from field: repeated devtool.emodel.v1.FloatingIndexDefinition floating_indexes = 1;
   */
  floatingIndexes: FloatingIndexDefinition[];
};

/**
 * Describes the message devtool.emodel.v1.ListFloatingIndexesResponse.
 * Use `create(ListFloatingIndexesResponseSchema)` to create a new message.
 */
export const ListFloatingIndexesResponseSchema: GenMessage<ListFloatingIndexesResponse> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 25);

/**
 * ListMarketIndexesリクエスト
 *
 * @generated from message devtool.emodel.v1.ListMarketIndexesRequest
 */
export type ListMarketIndexesRequest = Message<"devtool.emodel.v1.ListMarketIndexesRequest"> & {
};

/**
 * Describes the message devtool.emodel.v1.ListMarketIndexesRequest.
 * Use `create(ListMarketIndexesRequestSchema)` to create a new message.
 */
export const ListMarketIndexesRequestSchema: GenMessage<ListMarketIndexesRequest> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 26);

/**
 * ListMarketIndexesレスポンス
 *
 * @generated from message devtool.emodel.v1.ListMarketIndexesResponse
 */
export type ListMarketIndexesResponse = Message<"devtool.emodel.v1.ListMarketIndexesResponse"> & {
  /**
   * 市場指標（全件）
   *
   * @generated from field: repeated devtool.emodel.v1.MarketIndex market_indexes = 1;
   */
  marketIndexes: MarketIndex[];
};

/**
 * Describes the message devtool.emodel.v1.ListMarketIndexesResponse.
 * Use `create(ListMarketIndexesResponseSchema)` to create a new message.
 */
export const ListMarketIndexesResponseSchema: GenMessage<ListMarketIndexesResponse> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 27);

/**
 * FloatingIndexDefinition: 登録された変動指標の定義
 *
 * @generated from message devtool.emodel.v1.FloatingIndexDefinition
 */
export type FloatingIndexDefinition = Message<"devtool.emodel.v1.FloatingIndexDefinition"> & {
  /**
   * 変動指標の ID（UUID）
   *
   * @generated from field: string floating_index_id = 1;
   */
  floatingIndexId: string;

  /**
   * コード（eModel の中で一意。forward curve の ticker）
   *
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * 名前
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * 式ツリー（登録されたまま。部品の並びと定数の書き方を変えない）
   *
   * @generated from field: devtool.emodel.v1.FloatingIndexExpression expression = 4;
   */
  expression?: FloatingIndexExpression;

  /**
   * 式を文字に戻したもの（eModel が式ツリーから作る。商品の名前で書き、出どころの市場指標は含めない。
   * 例: "0.0068 × JKM(n) × JPYUSD(n-1)"、"0.16 × (JLC(n-2) − 95000) / 1000"、窓が 2 か月以上なら "JLC(n-3~5)"）。
   * 部品の並びと定数の書き方をそのまま出し、優先順位に要る括弧だけを付ける
   *
   * @generated from field: string expression_text = 5;
   */
  expressionText: string;

  /**
   * 登録者
   *
   * @generated from field: string registered_by = 6;
   */
  registeredBy: string;

  /**
   * 登録日時（eModel が登録を受け付けた日時）
   *
   * @generated from field: google.protobuf.Timestamp registered_at = 7;
   */
  registeredAt?: Timestamp;

  /**
   * forward の出どころ。ある定義だけ forward curve を書き出す。無ければ forward を書き出さない
   *
   * @generated from field: devtool.emodel.v1.FloatingIndexForwardSource forward_source = 10;
   */
  forwardSource?: FloatingIndexForwardSource;

  /**
   * historical の出どころ（作り方を含む）。ある定義だけ historical のシナリオを書き出す。無ければ historical を書き出さない。
   * eModel が初期の行で持つ LOGRET 系は、historical の出どころ（対数収益率）だけを持つ。
   * forward_source と historical_source の少なくとも片方はある。両方ある定義だけを約定に使う（ePosition が上場する）
   *
   * @generated from field: devtool.emodel.v1.FloatingIndexHistoricalSource historical_source = 11;
   */
  historicalSource?: FloatingIndexHistoricalSource;
};

/**
 * Describes the message devtool.emodel.v1.FloatingIndexDefinition.
 * Use `create(FloatingIndexDefinitionSchema)` to create a new message.
 */
export const FloatingIndexDefinitionSchema: GenMessage<FloatingIndexDefinition> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 28);

/**
 * FloatingIndexForwardSource: 変動指標の forward の出どころ。式の商品ごとに、値を引く forward の市場指標を選ぶ
 *
 * @generated from message devtool.emodel.v1.FloatingIndexForwardSource
 */
export type FloatingIndexForwardSource = Message<"devtool.emodel.v1.FloatingIndexForwardSource"> & {
  /**
   * 式の商品と forward の市場指標の組。式が参照する商品の全部に 1 つずつ選ぶ（選んでいない商品があれば eModel が断る）。
   * 市場指標は、種類が forward（MARKET_INDEX_KIND_FORWARD）で、組にした商品を指すもの
   *
   * @generated from field: repeated devtool.emodel.v1.FloatingIndexCommodityMarketIndex market_indexes = 1;
   */
  marketIndexes: FloatingIndexCommodityMarketIndex[];
};

/**
 * Describes the message devtool.emodel.v1.FloatingIndexForwardSource.
 * Use `create(FloatingIndexForwardSourceSchema)` to create a new message.
 */
export const FloatingIndexForwardSourceSchema: GenMessage<FloatingIndexForwardSource> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 29);

/**
 * FloatingIndexHistoricalSource: 変動指標の historical の出どころ。作り方と、式の商品ごとに値を引く historical の市場指標を選ぶ
 *
 * @generated from message devtool.emodel.v1.FloatingIndexHistoricalSource
 */
export type FloatingIndexHistoricalSource = Message<"devtool.emodel.v1.FloatingIndexHistoricalSource"> & {
  /**
   * historical のシナリオの作り方。価格の差分は forward の出どころを持つ定義だけに使える（出す tenor を自分の forward で絞るため）。
   * 対数収益率は forward の出どころが無くてよい
   *
   * @generated from field: devtool.emodel.v1.FloatingIndexHistoricalMethod method = 1;
   */
  method: FloatingIndexHistoricalMethod;

  /**
   * 式の商品と historical の市場指標の組。式が参照する商品の全部に 1 つずつ選ぶ（選んでいない商品があれば eModel が断る）。
   * 市場指標は、種類が historical（MARKET_INDEX_KIND_HISTORICAL）で、組にした商品を指すもの
   *
   * @generated from field: repeated devtool.emodel.v1.FloatingIndexCommodityMarketIndex market_indexes = 2;
   */
  marketIndexes: FloatingIndexCommodityMarketIndex[];
};

/**
 * Describes the message devtool.emodel.v1.FloatingIndexHistoricalSource.
 * Use `create(FloatingIndexHistoricalSourceSchema)` to create a new message.
 */
export const FloatingIndexHistoricalSourceSchema: GenMessage<FloatingIndexHistoricalSource> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 30);

/**
 * FloatingIndexCommodityMarketIndex: 式の商品と、その値を引く市場指標の組
 *
 * @generated from message devtool.emodel.v1.FloatingIndexCommodityMarketIndex
 */
export type FloatingIndexCommodityMarketIndex = Message<"devtool.emodel.v1.FloatingIndexCommodityMarketIndex"> & {
  /**
   * 式の商品の名前（例: "JKM"）。式の FloatingIndexMarketIndexReference.commodity と同じ名前
   *
   * @generated from field: string commodity = 1;
   */
  commodity: string;

  /**
   * 市場指標の名前（例: "ICE_JKM"）。ListMarketIndexes が返す名前のどれかで、種類は置かれた側
   * （forward の出どころなら forward、historical の出どころなら historical）の市場指標を指す
   *
   * @generated from field: string market_index = 2;
   */
  marketIndex: string;
};

/**
 * Describes the message devtool.emodel.v1.FloatingIndexCommodityMarketIndex.
 * Use `create(FloatingIndexCommodityMarketIndexSchema)` to create a new message.
 */
export const FloatingIndexCommodityMarketIndexSchema: GenMessage<FloatingIndexCommodityMarketIndex> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 31);

/**
 * FloatingIndexExpression: 変動指標の式ツリーの部品（1 ノード）。部品の種類はちょうど 1 つ。
 * 部品の種類は今後（上限・下限・条件分岐・丸めなど）足す。足すまでは、知らない部品を含む式を登録で断る。
 * 足しても登録済みの式の意味は変えない
 *
 * @generated from message devtool.emodel.v1.FloatingIndexExpression
 */
export type FloatingIndexExpression = Message<"devtool.emodel.v1.FloatingIndexExpression"> & {
  /**
   * @generated from oneof devtool.emodel.v1.FloatingIndexExpression.kind
   */
  kind: {
    /**
     * 定数
     *
     * @generated from field: devtool.emodel.v1.FloatingIndexConstant constant = 1;
     */
    value: FloatingIndexConstant;
    case: "constant";
  } | {
    /**
     * 市場指標の参照
     *
     * @generated from field: devtool.emodel.v1.FloatingIndexMarketIndexReference market_index = 2;
     */
    value: FloatingIndexMarketIndexReference;
    case: "marketIndex";
  } | {
    /**
     * 二項演算（四則）
     *
     * @generated from field: devtool.emodel.v1.FloatingIndexBinaryOperation binary_operation = 3;
     */
    value: FloatingIndexBinaryOperation;
    case: "binaryOperation";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message devtool.emodel.v1.FloatingIndexExpression.
 * Use `create(FloatingIndexExpressionSchema)` to create a new message.
 */
export const FloatingIndexExpressionSchema: GenMessage<FloatingIndexExpression> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 32);

/**
 * FloatingIndexConstant: 定数（係数・基準値・除数など）
 *
 * @generated from message devtool.emodel.v1.FloatingIndexConstant
 */
export type FloatingIndexConstant = Message<"devtool.emodel.v1.FloatingIndexConstant"> & {
  /**
   * 10 進の文字列（例: "0.0068"・"95000"・"-0.5"）。丸めずにそのまま保存し、"0.10" と "0.1" は別の内容として扱う。
   * 計算は浮動小数点で行う
   *
   * @generated from field: string value = 1;
   */
  value: string;
};

/**
 * Describes the message devtool.emodel.v1.FloatingIndexConstant.
 * Use `create(FloatingIndexConstantSchema)` to create a new message.
 */
export const FloatingIndexConstantSchema: GenMessage<FloatingIndexConstant> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 33);

/**
 * FloatingIndexMarketIndexReference: 式の市場指標の参照。商品の名前で参照し、限月 n の値に、商品の限月
 * n − lag_end_months 〜 n − lag_start_months の値を使う。各月の値は、forward では forward の出どころ、historical では
 * historical の出どころがその商品に選んだ市場指標から引く
 *
 * @generated from message devtool.emodel.v1.FloatingIndexMarketIndexReference
 */
export type FloatingIndexMarketIndexReference = Message<"devtool.emodel.v1.FloatingIndexMarketIndexReference"> & {
  /**
   * 商品の名前（例: "JKM"・"JPYUSD"。市場指標の名前 `<ソース>_<商品>` からソースを外した名前）。
   * eModel の商品の一覧にある名前のどれか（ListMarketIndexes の MarketIndex.commodity に出る）
   *
   * @generated from field: string commodity = 1;
   */
  commodity: string;

  /**
   * ラグの窓の開始（何か月前から。0 以上で、lag_end_months 以下）。単月なら lag_end_months と同じ値
   *
   * @generated from field: int32 lag_start_months = 2;
   */
  lagStartMonths: number;

  /**
   * ラグの窓の終了（何か月前まで。0 以上）
   *
   * @generated from field: int32 lag_end_months = 3;
   */
  lagEndMonths: number;

  /**
   * 窓の値の集約。窓が 2 か月以上のときは必須（AVERAGE）。窓が 1 か月なら見ない
   *
   * @generated from field: devtool.emodel.v1.FloatingIndexAggregation aggregation = 4;
   */
  aggregation: FloatingIndexAggregation;
};

/**
 * Describes the message devtool.emodel.v1.FloatingIndexMarketIndexReference.
 * Use `create(FloatingIndexMarketIndexReferenceSchema)` to create a new message.
 */
export const FloatingIndexMarketIndexReferenceSchema: GenMessage<FloatingIndexMarketIndexReference> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 34);

/**
 * FloatingIndexBinaryOperation: 二項演算（left 演算子 right）
 *
 * @generated from message devtool.emodel.v1.FloatingIndexBinaryOperation
 */
export type FloatingIndexBinaryOperation = Message<"devtool.emodel.v1.FloatingIndexBinaryOperation"> & {
  /**
   * 演算子
   *
   * @generated from field: devtool.emodel.v1.FloatingIndexOperator operator = 1;
   */
  operator: FloatingIndexOperator;

  /**
   * 左の式
   *
   * @generated from field: devtool.emodel.v1.FloatingIndexExpression left = 2;
   */
  left?: FloatingIndexExpression;

  /**
   * 右の式
   *
   * @generated from field: devtool.emodel.v1.FloatingIndexExpression right = 3;
   */
  right?: FloatingIndexExpression;
};

/**
 * Describes the message devtool.emodel.v1.FloatingIndexBinaryOperation.
 * Use `create(FloatingIndexBinaryOperationSchema)` to create a new message.
 */
export const FloatingIndexBinaryOperationSchema: GenMessage<FloatingIndexBinaryOperation> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 35);

/**
 * MarketIndex: 変動指標の出どころに選ぶ市場指標。ソースと商品と、forward か historical かの 1 本の系列
 *
 * @generated from message devtool.emodel.v1.MarketIndex
 */
export type MarketIndex = Message<"devtool.emodel.v1.MarketIndex"> & {
  /**
   * 名前（`<ソース>_<商品>`。例: "ICE_JKM"・"CME_JPYUSD"）。名前は種類ごとに一意で、同じ名前の市場指標が
   * 種類違いで 2 つありうる（"CME_JKM" の forward と "CME_JKM" の historical は別の市場指標）。
   * 市場指標を指すときは、名前と種類の組で見る
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * 種類（forward か historical か）。forward の市場指標は forward の出どころに、historical の市場指標は historical の出どころに選べる
   *
   * @generated from field: devtool.emodel.v1.MarketIndexKind kind = 4;
   */
  kind: MarketIndexKind;

  /**
   * 指す商品の名前（例: "JKM"）。式の商品（FloatingIndexMarketIndexReference.commodity）と同じ名前で、
   * 出どころでは、この商品と組にしたときだけ選べる
   *
   * @generated from field: string commodity = 5;
   */
  commodity: string;
};

/**
 * Describes the message devtool.emodel.v1.MarketIndex.
 * Use `create(MarketIndexSchema)` to create a new message.
 */
export const MarketIndexSchema: GenMessage<MarketIndex> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 36);

/**
 * @generated from enum devtool.emodel.v1.UnifiedAnalysisComponent
 */
export enum UnifiedAnalysisComponent {
  /**
   * @generated from enum value: UNIFIED_ANALYSIS_COMPONENT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: UNIFIED_ANALYSIS_COMPONENT_RISK = 1;
   */
  RISK = 1,

  /**
   * @generated from enum value: UNIFIED_ANALYSIS_COMPONENT_QUICK_PFE = 3;
   */
  QUICK_PFE = 3,

  /**
   * @generated from enum value: UNIFIED_ANALYSIS_COMPONENT_COMBINED_IM = 4;
   */
  COMBINED_IM = 4,
}

/**
 * Describes the enum devtool.emodel.v1.UnifiedAnalysisComponent.
 */
export const UnifiedAnalysisComponentSchema: GenEnum<UnifiedAnalysisComponent> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_risk_calc_engine_service, 0);

/**
 * ForwardCurveTenor: フォワードカーブの 1 点が表す期間。点の日付は期間の開始日。
 * 建玉の受渡期間の区分（PowerDeliveryPeriodType）とは別の概念で、カーブの点の粒度を表す
 *
 * @generated from enum devtool.emodel.v1.ForwardCurveTenor
 */
export enum ForwardCurveTenor {
  /**
   * 未指定（tenor の記録が無い）
   *
   * @generated from enum value: FORWARD_CURVE_TENOR_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 月（点の日付は月初）
   *
   * @generated from enum value: FORWARD_CURVE_TENOR_MONTH = 1;
   */
  MONTH = 1,

  /**
   * 四半期（4〜6 月・7〜9 月・10〜12 月・1〜3 月。点の日付は四半期の初日）
   *
   * @generated from enum value: FORWARD_CURVE_TENOR_QUARTER = 2;
   */
  QUARTER = 2,

  /**
   * 半期（4〜9 月・10〜3 月。点の日付は半期の初日）
   *
   * @generated from enum value: FORWARD_CURVE_TENOR_SEASON = 3;
   */
  SEASON = 3,

  /**
   * 年度（4/1 始まりの 1 年。点の日付は 4/1）
   *
   * @generated from enum value: FORWARD_CURVE_TENOR_FISCAL_YEAR = 4;
   */
  FISCAL_YEAR = 4,

  /**
   * 12〜2 月（点の日付は 12/1）
   *
   * @generated from enum value: FORWARD_CURVE_TENOR_DEC_FEB = 5;
   */
  DEC_FEB = 5,

  /**
   * 日（受渡日ごとの点）
   *
   * @generated from enum value: FORWARD_CURVE_TENOR_DAY = 6;
   */
  DAY = 6,
}

/**
 * Describes the enum devtool.emodel.v1.ForwardCurveTenor.
 */
export const ForwardCurveTenorSchema: GenEnum<ForwardCurveTenor> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_risk_calc_engine_service, 1);

/**
 * FloatingIndexHistoricalMethod: 変動指標の historical のシナリオの作り方。どちらも、取引日・tenor ごとに式を評価した
 * 価格の系列から作る
 *
 * @generated from enum devtool.emodel.v1.FloatingIndexHistoricalMethod
 */
export enum FloatingIndexHistoricalMethod {
  /**
   * 未指定
   *
   * @generated from enum value: FLOATING_INDEX_HISTORICAL_METHOD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 価格の差分（前の取引日との差を基準日の水準に足す）
   *
   * @generated from enum value: FLOATING_INDEX_HISTORICAL_METHOD_PRICE_DIFFERENCE = 1;
   */
  PRICE_DIFFERENCE = 1,

  /**
   * 対数収益率（前の取引日との対数収益率を基準日の水準に掛ける）
   *
   * @generated from enum value: FLOATING_INDEX_HISTORICAL_METHOD_LOG_RETURN = 2;
   */
  LOG_RETURN = 2,
}

/**
 * Describes the enum devtool.emodel.v1.FloatingIndexHistoricalMethod.
 */
export const FloatingIndexHistoricalMethodSchema: GenEnum<FloatingIndexHistoricalMethod> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_risk_calc_engine_service, 2);

/**
 * FloatingIndexAggregation: ラグの窓の値の集約の仕方
 *
 * @generated from enum devtool.emodel.v1.FloatingIndexAggregation
 */
export enum FloatingIndexAggregation {
  /**
   * 未指定（窓が 1 か月のときだけ使える）
   *
   * @generated from enum value: FLOATING_INDEX_AGGREGATION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 単純平均。窓のうち 1 か月でも値が無い限月は値を出さない
   *
   * @generated from enum value: FLOATING_INDEX_AGGREGATION_AVERAGE = 1;
   */
  AVERAGE = 1,
}

/**
 * Describes the enum devtool.emodel.v1.FloatingIndexAggregation.
 */
export const FloatingIndexAggregationSchema: GenEnum<FloatingIndexAggregation> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_risk_calc_engine_service, 3);

/**
 * FloatingIndexOperator: 四則の演算子
 *
 * @generated from enum devtool.emodel.v1.FloatingIndexOperator
 */
export enum FloatingIndexOperator {
  /**
   * 未指定（登録では使えない）
   *
   * @generated from enum value: FLOATING_INDEX_OPERATOR_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 足す
   *
   * @generated from enum value: FLOATING_INDEX_OPERATOR_ADD = 1;
   */
  ADD = 1,

  /**
   * 引く（left − right）
   *
   * @generated from enum value: FLOATING_INDEX_OPERATOR_SUBTRACT = 2;
   */
  SUBTRACT = 2,

  /**
   * 掛ける
   *
   * @generated from enum value: FLOATING_INDEX_OPERATOR_MULTIPLY = 3;
   */
  MULTIPLY = 3,

  /**
   * 割る（left / right）。割る数が 0、または評価の途中で数でない値になった限月は値を出さない
   *
   * @generated from enum value: FLOATING_INDEX_OPERATOR_DIVIDE = 4;
   */
  DIVIDE = 4,
}

/**
 * Describes the enum devtool.emodel.v1.FloatingIndexOperator.
 */
export const FloatingIndexOperatorSchema: GenEnum<FloatingIndexOperator> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_risk_calc_engine_service, 4);

/**
 * MarketIndexKind: 市場指標の種類
 *
 * @generated from enum devtool.emodel.v1.MarketIndexKind
 */
export enum MarketIndexKind {
  /**
   * 未指定
   *
   * @generated from enum value: MARKET_INDEX_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * forward の市場指標（forward curve を読む。forward の出どころに選べる）
   *
   * @generated from enum value: MARKET_INDEX_KIND_FORWARD = 1;
   */
  FORWARD = 1,

  /**
   * historical の市場指標（historical の価格の系列を読む。historical の出どころに選べる）
   *
   * @generated from enum value: MARKET_INDEX_KIND_HISTORICAL = 2;
   */
  HISTORICAL = 2,
}

/**
 * Describes the enum devtool.emodel.v1.MarketIndexKind.
 */
export const MarketIndexKindSchema: GenEnum<MarketIndexKind> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_risk_calc_engine_service, 5);

